import ClientLandingPage from "../client_landing/ClientLandingPage";

export default function DashboardHome() {
  return <ClientLandingPage />;
}
